import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f2d64f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    ref: "skeletonElement",
    class: "document-view-content-page"
};
const _hoisted_2 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PageSkeletonLoader = _resolveComponent("PageSkeletonLoader");
    const _component_ViewField = _resolveComponent("ViewField");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showLoader)
            ? (_openBlock(), _createBlock(_component_PageSkeletonLoader, {
                key: 0,
                "page-height": _ctx.skeletonHeight
            }, null, 8, ["page-height"]))
            : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", null, [
            (_ctx.imageError)
                ? (_openBlock(), _createBlock(_component_PageSkeletonLoader, {
                    key: 0,
                    "page-height": _ctx.skeletonHeight,
                    timeout: 3000,
                    "timeout-message": _ctx.t('this-page-is-taking-longer-than-usual-try-refresh')
                }, null, 8, ["page-height", "timeout-message"]))
                : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("img", {
                src: _ctx.thumbUrl,
                alt: _ctx.imageDescription(_ctx.page.pageNum),
                "data-external": "doc-view-doc-content-page-loaded",
                class: "document-content-page-loaded",
                onLoad: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.handleImageLoaded && _ctx.handleImageLoaded(...args))),
                onError: _cache[1] || (_cache[1] =
                    //@ts-ignore
                    (...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
            }, null, 40, _hoisted_2), [
                [_vShow, _ctx.imageLoaded]
            ]),
            (_ctx.showFields)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.fields, (field, index) => {
                    return (_openBlock(), _createBlock(_component_ViewField, {
                        key: field.id,
                        "data-external": `view-field-container(${index})`,
                        field: field,
                        sender: _ctx.sender,
                        recipients: _ctx.recipients
                    }, null, 8, ["data-external", "field", "sender", "recipients"]));
                }), 128))
                : _createCommentVNode("", true)
        ], 512), [
            [_vShow, !_ctx.showLoader]
        ])
    ], 512)), [
        [_vShow, _ctx.skeletonHeight || _ctx.imageLoaded]
    ]);
}
